import * as React from 'react';
import { connect } from 'react-redux';
import { Card } from 'react-bootstrap';
import './Policy.css';

export interface NotificationProperties {
    type: string,
    claimNumber: string,
    header: string,
    description: string,
    status: string,
    eventNumber: string,
}

class Notification extends React.Component<NotificationProperties> {
    render() {
        return (
            <>
                <div className="d-none d-lg-block d-md-none" id="ProgressDesktop">
                    <div className="col-lg-12 pl-0 pb-lg-3">
                        {this.props.type === "Claim" &&
                            <Card className="tile tileHeight">
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-lg-4 pr-0">
                                            <label className="HashNumber mb-0">#{this.props.eventNumber}</label>
                                            <p className="ActivePolicies">{this.props.status}</p>
                                        </div>
                                        <div className="col-lg-8 p-0">
                                            <p className="font-weight-bold mb-0">{this.props.header}</p>
                                            <p className="policyNumber mb-0">{this.props.description}</p>
                                            <p className="policyNumber">Claim no. <span className="font-weight-bold">{this.props.claimNumber}</span></p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        }
                        {this.props.type === "Reminder" &&
                            <Card className="tile tileHeight">
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-lg-12 pr-0">
                                            <p className="font-weight-bold mb-0">{this.props.header}</p>
                                            <p className="policyNumber mb-0">{this.props.description}</p>
                                            <p className="policyNumber">Status: <span className="font-weight-bold status">{this.props.status}</span></p>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        }
                    </div>
                </div>
                <div className="d-block d-lg-none d-md-block ml-2 mr-2" id="ProgressMobile">
                    {this.props.type === "Claim" &&
                        <div className="tile-mobile ml-2 mr-2 mb-3">
                            <div className="row">
                                <div className="col-4 pr-0">
                                    <label className="HashNumber mb-0">#{this.props.eventNumber}</label>
                                    <p className="ActivePolicies">{this.props.status}</p>
                                </div>
                                <div className="col-4 p-0">
                                    <p className="font-weight-bold mb-0">{this.props.header}</p>
                                    <p className="policyNumber mb-0">{this.props.description}</p>
                                </div>
                                <div className="col-4 text-right">
                                    <p className="policyNumber mb-0">Claim no.</p>
                                    <p className="policyNumber pr-0"><span className="font-weight-bold">{this.props.claimNumber}</span></p>
                                </div>
                            </div>
                        </div>
                    }
                    {this.props.type === "Reminder" &&
                        <div className="tile-mobile ml-2 mr-2 mb-3">
                            <div className="row">
                                <div className="col-6 pr-0">
                                    <p className="font-weight-bold mb-0">{this.props.header}</p>
                                    <p className="policyNumber mb-0">{this.props.description}</p>
                                </div>
                                <div className="col-6 text-right">
                                    <p className="policyNumber mb-0">Status:</p>
                                    <p className="policyNumber"><span className="font-weight-bold status">{this.props.status}</span></p>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile
    }
}
export default connect(mapStateToProps)(Notification);
